import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({ theme: "dark", toggleTheme: () => {}, setTheme: () => {} });

function apply(theme) {
    const el = document.documentElement;
    if (theme === "light") el.classList.add("light");
    else el.classList.remove("light");
}

function animateThemeChange() {
    const el = document.documentElement;
    el.classList.add("theme-anim");
    window.setTimeout(() => el.classList.remove("theme-anim"), 450);
}

export function ThemeProvider({ children }) {
    const [theme, setThemeState] = useState(() => {
        try { return localStorage.getItem("tsi-theme") === "light" ? "light" : "dark"; } catch { return "dark"; }
    });

    useEffect(() => {
        apply(theme);
        try { localStorage.setItem("tsi-theme", theme); } catch { /* ignore */ }
    }, [theme]);

    const setTheme = (t) => { animateThemeChange(); setThemeState(t === "light" ? "light" : "dark"); };
    const toggleTheme = () => { animateThemeChange(); setThemeState((t) => (t === "light" ? "dark" : "light")); };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme, setTheme }}>
            {children}
        </ThemeContext.Provider>
    );
}

export const useTheme = () => useContext(ThemeContext);
